import React from 'react'
import  './Footer.scss'

function Footer() {
    return (
        <div>
           <div className='footerWrapper'>
               <h6>Copyright &copy; 2022. All rights are reserved.</h6>
           </div>
        </div>
    )
}

export default Footer
